import Leaderboards from './Leaderboards'
import Threads from './Threads'
import CommentForm from './CommentForm'
import Comment from './Comment'

export default { Leaderboards, Threads, CommentForm, Comment }
